import ModalController from "./modal_controller";
import fetchExternalPositionFlights from "../services/externalPositionsService/fetchFlights";

export default class extends ModalController {
  static targets = ["flightList", "rowTemplate"];

  static values = {
    noFlightsAvailable: String,
    errorFetchingFlights: String,
    flightSelectionNotAvailable: String,
  };

  initialize() {
    super.initialize();
    this.externalPositionId = null;
    this.contextData = {};
  }

  showModal(event) {
    const { draggedData, targetData, transferDirection } = event.detail;

    this.externalPositionId = draggedData.id;
    this.contextData = {
      draggedData,
      targetData,
      transferDirection,
    };

    this.openModal();
  }

  dispatchError(message, error) {
    const customEvent = new CustomEvent(
      "external-position-flight-selection-modal:error",
      {
        detail: {
          message,
          error,
          externalPositionId: this.externalPositionId,
          contextData: this.contextData,
        },
      }
    );

    window.dispatchEvent(customEvent);
  }

  dispatchSuccess(flightData) {
    const customEvent = new CustomEvent(
      "external-position-flight-selection-modal:flightSelected",
      {
        detail: {
          flightData,
          externalPositionId: this.externalPositionId,
          contextData: this.contextData,
        },
        bubbles: true,
      }
    );

    this.element.dispatchEvent(customEvent);
  }

  addFlightRow(flight) {
    const template = this.rowTemplateTarget.content.cloneNode(true);
    const row = template.querySelector("tr");

    row.dataset.flightId = flight.id;
    row.dataset.externalPositionFlightId = flight.external_position_flight_id;
    row.dataset.departureAt = flight.departure_at;
    row.dataset.arrivalAt = flight.arrival_at;

    row.querySelector("[data-airline-code]").textContent = flight.airline_code;
    row.querySelector("[data-flight-number]").textContent =
      flight.flight_number;
    row.querySelector("[data-departure-airport]").textContent =
      flight.departure_airport;
    row.querySelector("[data-arrival-airport]").textContent =
      flight.arrival_airport;
    row.querySelector("[data-departure-time]").textContent = new Date(
      flight.departure_at
    ).toLocaleString();
    row.querySelector("[data-arrival-time]").textContent = new Date(
      flight.arrival_at
    ).toLocaleString();

    this.flightListTarget.appendChild(row);
  }

  openModal() {
    if (!this.externalPositionId) {
      this.dispatchError(this.flightSelectionNotAvailableValue, null);
      return;
    }

    super.openModal();

    fetchExternalPositionFlights({
      externalPositionId: this.externalPositionId,
      success: (response) => {
        const { flights } = response;
        if (!flights || !flights.length) {
          this.dispatchError(this.noFlightsAvailableValue, null);
          return;
        }
        this.flightListTarget.innerHTML = "";
        flights.forEach((flightData) => this.addFlightRow(flightData));
      },
      error: (error) => {
        this.dispatchError(this.errorFetchingFlightsValue, error);
      },
    });
  }

  selectFlight(event) {
    const row = event.target.closest("tr");
    const flightData = {
      externalPositionFlightId: row.dataset.externalPositionFlightId,
      airlineCode: row.querySelector("[data-airline-code]").textContent,
      flightNumber: row.querySelector("[data-flight-number]").textContent,
      departureAirport: row.querySelector("[data-departure-airport]")
        .textContent,
      arrivalAirport: row.querySelector("[data-arrival-airport]").textContent,
      departureAt: row.dataset.departureAt,
      arrivalAt: row.dataset.arrivalAt,
    };

    this.closeModal(event);
    this.dispatchSuccess(flightData);
  }

  hide(event) {
    if (event) {
      event.preventDefault();
    }

    const customEvent = new CustomEvent(
      "external-position-flight-selection-modal:canceled",
      {
        detail: {
          contextData: this.contextData,
        },
        bubbles: true,
      }
    );

    this.closeModal(event);
    this.element.dispatchEvent(customEvent);
  }
}
